module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cut_off_time":"Cut-off time","orders_less_than_processed":"Orders made less than {time} will be processed the next business day."},"id":{"cut_off_time":"Waktu Cut-off","orders_less_than_processed":"Pesanan yang dibuat sebelum jam {time} akan diproses pada hari kerja berikutnya."}}')
  delete Component.options._Ctor
}
